export enum PcHeaderType {
  Common = 'COMMON',
  Viewer = 'VIEWER',
  ViewerComment = 'VIEWER_COMMENT',
  Back = 'Back',
}
